
import Swiper, { Navigation, Pagination } from 'swiper'

import { q } from '../helper/q'

Swiper.use([Navigation, Pagination])

export const sliderInit = () => {
  const slider = q('.aboutHistorySlider')
  if (slider) {
    // console.log(vwTOpx(getComputedStyle(document.documentElement).getPropertyValue('--indent-horizontal-medium').split('vw')[0]))
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      setWrapperSize: true,
      slidesOffsetBefore: getOffset(),
      slidesOffsetAfter: getOffset(),
      autoHeight: true,
      navigation: {
        nextEl: '.aboutHistorySliderNext',
        prevEl: '.aboutHistorySliderPrev',
      },
      breakpoints: {
        1280: {
          slidesPerView: 2,
          autoHeight: false,
        },
      },
    })
    swiper.on('resize', () => {
      swiper.params.slidesOffsetAfter = getOffset()
      swiper.params.slidesOffsetBefore = getOffset()
    })
  }
}

const getOffset = () => {
  const offsetFromCSS = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--indent-horizontal-medium')
  if (!offsetFromCSS) return 0
  // Получим value и unit из значения.
  const regex = /[+-]?\d+(\.\d+)?/g
  const value = offsetFromCSS.match(regex)[0]
  const unit = offsetFromCSS.match(/[a-zA-z]+/g)[0]
  // и отдадим в зависиомсти от unit
  return unit === 'vw'
    ? (document.documentElement.clientWidth * value) / 100
    : value
}
